export const announcementChannels = [
  { id: "mon-interim", label: "Mon Intérim" },
  { id: "site", label: "Le site" },
  { id: "france-travail", label: "Pôle emploi" },
  { id: "hellowork", label: "HelloWork" },
];
export const websiteChannelId = "site";
export const applicationStatuses = ["Sourcing", "Nouveau", "En attente", "Présélection", "Sélectionné", "Entretien tel", "RDV Agence", "RDV physique", "Shortlist", "Proposés Client", "Proposition", "RDV avec Client", "Recruté", "Refusé"];
export function announcementApplications(announcement) {
  return (Array.isArray(announcement.candidats) ? announcement.candidats : [])
    .map((entry) => {
      const candidate =
        entry.candidateId && typeof entry.candidateId === "object"
          ? entry.candidateId
          : entry;
      return {
        ...candidate,
        _id: (typeof entry.candidateId === "object" ? entry.candidateId?._id : entry.candidateId) || candidate._id,
        status: entry.status || "Nouveau",
        date: entry.date,
        source: entry.source || candidate.source,
      };
    })
    .filter((candidate) => candidate._id);
}
export function applicationPayload(announcement, candidateId, status, source) {
  return (announcement.candidats || []).map((entry) => {
    const id =
      typeof entry.candidateId === "object"
        ? entry.candidateId?._id
        : entry.candidateId || entry._id;
    return {
      ...entry,
      candidateId: id,
      ...(String(id) === String(candidateId) && source !== undefined ? { source } : {}),
      status:
        String(id) === String(candidateId) ? status : entry.status || "Nouveau",
    };
  });
}
export function safePublicationUrl(value) {
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
}
export function announcementText(announcement) {
  return [
    announcement.title,
    announcement.localisation || announcement.town,
    announcement.jobType,
    announcement.description,
    announcement.profilRecherche,
    announcement.salaire
      ? `Rémunération : ${announcement.salaire} ${announcement.baseSalary || ""}`
      : "",
    announcement.dateDebutSouhaitee
      ? `Début souhaité : ${announcement.dateDebutSouhaitee}`
      : "",
    announcement.tempTravail,
    announcement.informationsComplementaires,
    [announcement.email, announcement.phone].filter(Boolean).join(" · "),
  ]
    .filter(Boolean)
    .join("\n\n");
}

export const isDirectAnnouncementChannel = id => ['site', 'mon-interim'].includes(id);
export function announcementChannelActive(announcement, tracking, id) {
  return id === 'site' ? !!announcement.isActive : id === 'mon-interim' ? !!announcement.monInterimActive : tracking?.channels?.[id]?.state === 'Publié';
}

export function sortApplicationsByStatus(applications) {
  const rank = value => { const index = applicationStatuses.indexOf(value); return index < 0 ? applicationStatuses.length : index; };
  return [...applications].sort((a, b) => rank(a.status) - rank(b.status) ||
    (new Date(b.date || 0).getTime() || 0) - (new Date(a.date || 0).getTime() || 0) ||
    `${a.lastname || ''} ${a.firstname || ''}`.localeCompare(`${b.lastname || ''} ${b.firstname || ''}`, 'fr', { sensitivity: 'base' }));
}

export function announcementCvCandidateId(candidate) {
  const source = candidate.sourceCandidate;
  return (typeof source === "object" ? source?._id || source?.id : source) || candidate._id;
}
export function announcementCvBase64(value) {
  return typeof value === "string" ? value.replace(/^data:[^,]+,/, "").replace(/\s/g, "") : "";
}
